import React, { useEffect } from 'react';
import usePartyId from '../../../../common/src/hooks/query-params/usePartyId';
import {
  useCompanyScanDispatch,
  useCompanyScanSelector,
} from '../../../../common/src/utils/globalVariables';
import { useParty } from '../../../../parties/src/features/detail/api/getParty';
import { setSelectedCompany } from '../../../store/redux/slices/companyScanSlice';
import { mapPartyToCompany } from '../../../utils/mappingUtils';

const CompanyScanPartyProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const partyId = usePartyId();
  const { data: party, isSuccess } = useParty(partyId);
  const companyScanDispatch = useCompanyScanDispatch();
  const selectedCompany = useCompanyScanSelector(
    (state) => state.companyScan.selectedCompany,
  );

  useEffect(() => {
    if (party && isSuccess && selectedCompany == null)
      companyScanDispatch(setSelectedCompany(mapPartyToCompany(party)));
  }, [isSuccess]);

  return <>{children}</>;
};

export default CompanyScanPartyProvider;
